import { loadableWithRetry } from '../../common/utils/lazyLoad'

const routes = [
  {
    path: '/review-rule-sets',
    component: loadableWithRetry(() => import('./ReviewRuleSets')),
    name: 'reviewRuleSets',
    publicRoute: true,
    exact: true,
  },
  {
    path: '/review-rule-sets/:id',
    name: 'singleReviewRuleSet',
    component: loadableWithRetry(() => import('./SingleReviewRuleSet')),
    publicRoute: true,
    exact: true,
  },
  {
    path: '/review-rule-sets/:id/new-rule',
    name: 'createReviewRule',
    component: loadableWithRetry(() => import('./CreateReviewRule')),
    publicRoute: true,
    exact: true,
  },
  {
    path: '/review-rule-sets/:id/edit-rule/:ruleName',
    name: 'editReviewRule',
    component: loadableWithRetry(() => import('./EditReviewRule')),
    publicRoute: true,
    exact: true,
  },
]

export default routes
